var fn = function( obj ){
var __t,__p='';
__p+='FragColor.rgb = vec3(1., 1., 1.);\nFragColor.a = uAlpha;';
return __p;
};
fn.toString=fn;
module.exports = fn;